import React from 'react';
import { Check } from 'lucide-react';

const Benefits = () => {
  const benefits = [
    {
      category: 'Health & Wellness',
      items: [
        'Comprehensive health, dental, and vision insurance',
        'Mental health support and wellness programs',
        'Flexible PTO policy',
        'Paid parental leave'
      ]
    },
    {
      category: 'Work-Life Balance',
      items: [
        'Remote-first with flexible hours',
        'Home office stipend',
        'Annual team retreats',
        'No meeting Fridays'
      ]
    },
    {
      category: 'Growth & Development',
      items: [
        'Learning & development budget',
        'Conference and event attendance',
        'Mentorship programs',
        'Clear career progression paths'
      ]
    },
    {
      category: 'Compensation & Equity',
      items: [
        'Competitive salary',
        'Equity compensation',
        '401(k) with company match',
        'Performance bonuses'
      ]
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            Benefits & Perks
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            We invest in our team's success, health, and happiness.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gray-900 rounded-2xl p-8 border border-gray-800"
            >
              <h3 className="text-2xl font-bold text-white mb-6">{benefit.category}</h3>
              <ul className="space-y-4">
                {benefit.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-300">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;